// extracted by mini-css-extract-plugin
export default {"loadingContainer":"QuizCyberpunkDriving_loadingContainer__3lc6h","loadingText":"QuizCyberpunkDriving_loadingText__GOD-J"};